import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { commonActions, contracterActions, certboxActions, modalActions } from '../../../../store/actions'

import CertboxReadingList from './CertboxReadingList'
import queryString from 'query-string'
import Pagination from '../../../../module/pagination-box'
import history from '../../../../route/history'
import store from '../../../../store'

const CertboxReading = (props) => {
  const [state, setState] = useState({})
  useEffect(() => {
    if (props.match.params.onetmPrslCntnTocken) {
      let onetmPrslCntnTocken = props.match.params.onetmPrslCntnTocken
      props.readcertboxReadingList(onetmPrslCntnTocken)
    }
  }, [])

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }

  return (
    <>
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <a href="#" className="page-prev" onClick={prePage}>
            뒤로이동
          </a>
          {/* mobile */}
          <h2>증명서 1회 열람</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>전자문서지갑</span>
            <em>증명서 1회 열람</em>
          </div>
        </div>

        <CertboxReadingList data={props.certboxReadingList} />
        <div className="guide-box gray mt20">
          <dl className="dlist1">
            <dt>증명서 1회 열람 안내</dt>
            <dd>증명서별 열람후 해당 증명서는 열람할 수 없습니다.</dd>
            <dd>증명서 열람이 완료된 증명서는 목록에서 사라집니다.</dd>
          </dl>
        </div>
      </div>
      {/* //contents */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    certboxReadingList: state.certbox?.certboxReadingList?.list,
  }
}

const actionCreators = {
  changeSearchInfo: certboxActions.changeSearchInfo,
  readcertboxReadingList: certboxActions.readcertboxReadingList,
}

export default connect(mapStateToProps, actionCreators)(CertboxReading)
